var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderAcademics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.896,
    height: 45.789,
    viewBox: "0 0 54.896 45.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mortarboard",
    transform: "translate(0 -42.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55676",
    "data-name": "Path 55676",
    d: "M53.823,51.677,27.983,42.56a1.608,1.608,0,0,0-1.07,0L1.073,51.677a1.608,1.608,0,0,0,0,3.032l25.84,9.186a1.607,1.607,0,0,0,1.077,0l25.84-9.186a1.608,1.608,0,0,0,0-3.032Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55677",
    "data-name": "Path 55677",
    d: "M435.686,211.762V197.734l-3.217,1.144v12.885a3.229,3.229,0,0,0,0,5.6v7.9a1.608,1.608,0,1,0,3.217,0v-7.9a3.229,3.229,0,0,0,0-5.6Z",
    transform: "translate(-384.653 -138.619)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55678",
    "data-name": "Path 55678",
    d: "M121.586,227.855a4.812,4.812,0,0,1-1.616-.279l-14.526-5.164v7.077c0,1.732,1.806,3.2,5.369,4.352a37.914,37.914,0,0,0,21.547,0c3.562-1.156,5.369-2.621,5.369-4.352v-7.077L123.2,227.576A4.813,4.813,0,0,1,121.586,227.855Z",
    transform: "translate(-94.138 -160.651)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderAcademics);
export default __webpack_public_path__ + "static/media/profile-builder-academics.ccde718e15b173300d2a4139469ffa3c.svg";
export { ForwardRef as ReactComponent };